<template>
  <section>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-6 col-sm-4 col-lg-2 mb-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
            @click="soidown = !soidown"
          >
            สอยดาว
          </button>
        </div>
        <div class="col-6 col-sm-4 col-lg-2 mb-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
            @click="filterFunction('yeekee_jetsada')"
          >
            ยี่กี JETSADA
          </button>
        </div>
        <div class="col-6 col-sm-4 col-lg-2 mb-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
            @click="filterFunction('yeekee_huay')"
          >
            ยีกี HUAY
          </button>
        </div>
        <div class="col-6 col-sm-4 col-lg-2 mb-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
          >
            หวยหุ้น
          </button>
        </div>
        <div class="col-6 col-sm-4 col-lg-2 mb-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
          >
            หวยรัฐ
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div
        v-for="result in results"
        :key="result.id"
        ref="{{result.slug}}"
        :v-show="soidown"
        :class="resultBoxClass"
      >
        <div class="col-12">
          ผลรางวัล {{ result.name }}
        </div>
        <div
          v-for="n in result.latestGameWithResults"
          :key="n.id"
          class="col-12 mb-3 col-sm-3 col-md-2 col-lg-2"
        >
          <result-item
            :id="n.id"
            :digit-under="`0`"
            :digit-upper="`0`"
            :status="n.status"
            :close-at="n.close_at"
            :title="result.name"
            :round-read="result.readableEdition"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Result',
  props: {
    results: { type: Array, required: true },
    // roundRead: { type: String, default: '' },
    // digitUpper: { type: String, default: 'รอผล' },
    // digitUnder: { type: String, default: 'รอผล' },
    // closeAt: { type: String, default: '' },
    // secondsLeft: { type: Number, default: 0 },
    // gameLink: { type: String, default: '#' },
    // status:{ type: String, default: 'open'}
  },

  data() {
    return {
      showAble: 'all',
      resultBoxClass: 'row resultBox',
      soidown: true,
    };
  },

  computed: {
    // filterFunction(data){
    //   alert(data);
    // }
  },

  mounted() {},

  methods: {
    filterFunction(message) {
      // this.$refs[message].resultBoxClass = 'd-none';
      this.soidown = !this.soidown;
      // this.showAble = message;
      // this.$refs.soidown.show();
    },
  },
};
</script>
